import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { Skeleton } from '@material-ui/lab';

export default function ScoreTable(props) {
  const courseScores = props.courseScores;

  let pickHeading = (str) => {
    switch (str) {
      case 'Criteria':
        return '';
      case 'MentalAbility':
        return 'Mental Ability';

      case 'Sst':
        return 'Social Study';

      case 'Maximum Marks':
        return 'Maximum';

      case 'Highest Score':
        return 'Highest';
      case 'Average Score':
        return 'Average';
      case 'Your Score':
        return 'Score';
      case 'Your Percentile':
        return '%Tile';

      default:
        return str;
    }
  };

  const setHeader = () => {
    let header = Object.keys(courseScores[0]);
    let finalHeader = ['Criteria'];
    header.map((head) => {
      head !== 'RID' && head !== 'Criteria' && finalHeader.push(head);
    });
    return finalHeader;
  };
  const setCell = (row) => {
    const cell = [];
    (props.isFetching ? [1,1,1,1,1] : header).map((head, index) => {
      cell.push(
        <TableCell className="table-cell-data" key={index}>
          {props.isFetching ? <Skeleton/> : !isEmpty(row[head]) ? pickHeading(row[head]) : '-'}
        </TableCell>
      );
    });
    return cell;
  };
  const setRow = () => {
    const row = [];
    (props.isFetching ? [1,1,1,1,1,1,1] : courseScores).map((item, index) => {
      row.push(<TableRow key={index}>{setCell(item)}</TableRow>);
    });
    return row;
  };
  const header = !props.isFetching && setHeader();

  const getHeaders = () => {
    const columns = [];
    (props.isFetching ? [1,1,1,1,1] : header).map((item, index) => {
      columns.push(
        <TableCell className="table-cell-data" key={index}>
          {props.isFetching ? <Skeleton/> : item === 'Criteria' ? '' : item}
        </TableCell>
      );
    });
    return columns;
  };

  return ((courseScores && courseScores.length > 0 || props.isFetching) ?
    <TableContainer className="table-container nowrap">
      <Table size="small">
        <TableHead>
          <TableRow>{getHeaders()}</TableRow>
        </TableHead>
        <TableBody>{setRow()}</TableBody>
      </Table>
    </TableContainer>
  : <div>No Table Scores Available</div>
  )}

ScoreTable.propTypes = {
  courseScores: PropTypes.array,
  isFetching: PropTypes.bool
};
